import { Box, Text } from '@mantine/core';
import type { FieldMemo, Field } from '../../types';
import { MemoItem } from './MemoItem';

interface MemoListProps {
  memos: FieldMemo[];
  fields: Field[];
}

export function MemoList({ memos, fields }: MemoListProps) {
  const fieldNameMap = new Map(
    fields.filter((f) => f.name !== undefined).map((f) => [f.id, f.name as string])
  );

  if (memos.length === 0) {
    return (
      <Text size="sm" c="dimmed">
        メモはありません
      </Text>
    );
  }

  return (
    <Box style={{ overflowY: 'auto', flex: 1 }}>
      {memos.map((memo) => (
        <Box
          key={memo.id}
          style={{
            borderTop: '1px solid var(--mantine-color-gray-3)',
          }}
        >
          <MemoItem memo={memo} fieldName={fieldNameMap.get(memo.entityId)} />
        </Box>
      ))}
    </Box>
  );
}
